import React, { useState } from "react";
import axios from "axios";
import A1 from '../Images/elo.png';
import ReCAPTCHA from "react-google-recaptcha";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Whatsapplogin = () => {
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Send OTP
  const handleSendOtp = async () => {
    if (!whatsappNumber || whatsappNumber.length !== 10) {
      setMessage("Enter a valid 10-digit WhatsApp number.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post("https://cloudapi.emedhatechnologies.com/pages/api/api/send-otp", { whatsappNumber });
      setLoading(false);

      if (response.data.success) {
        setMessage("OTP sent successfully!");
        setIsOtpSent(true);
      } else {
        // Show alert for backend failure
        alert(response.data.message || "You are not an User. Please Contact Your Admin.");
        setMessage(response.data.message || "Failed to send OTP.");
      }
    } catch (error) {
      setLoading(false);

      // Correctly get message from backend response
      const errMsg =
        error.response?.data?.message || // <-- this is your backend message
        "Server error. Try again.";

      alert(errMsg); // show alert
      setMessage(errMsg);
    }
  };



  const handleVerifyOtp = async () => {

    if (!otp || otp.length !== 6) {
      setMessage("Enter valid OTP");
      return;
    }

    setLoading(true);

    try {

      const response = await axios.post("https://cloudapi.emedhatechnologies.com/pages/api/api/verify-otp",
        {
          whatsappNumber,
          otpCode: otp
        }
      );

      setLoading(false);

      const data = response.data;

      if (!data.success) {
        setMessage(data.message);
        return;
      }

      // ======================
      // COMPANY LOGIN
      // ======================

      if (data.type === "company") {

        sessionStorage.setItem(
          "userData",
          JSON.stringify({
            type: "company",
            id: data.user.id,
            email: data.user.email,
            mobile: data.user.mobile,
            company_name: data.user.company_name,
          })
        );

        if (data.user.company_logo) {
          sessionStorage.setItem(
            "companyLogo",
            data.user.company_logo
          );
        }

        navigate("/dashboard/home");
        return;
      }

      // ======================
      // EMPLOYEE LOGIN
      // ======================

      if (data.type === "employee") {

        sessionStorage.setItem(
          "userData",
          JSON.stringify({
            type: "employee",
            id: data.user.id,
            parent_company_id: data.user.parent_company_id,
            email: data.user.email,
            mobile: data.user.mobile,
            name: data.user.name,
            user_type: data.user.user_type,
            company_name: data.user.company_name,
            company_logo: data.user.company_logo,
            permissions: data.user.permissions
          })
        );

        if (data.user.company_logo) {
          sessionStorage.setItem(
            "companyLogo",
            data.user.company_logo
          );
        }

        navigate("/dashboard/home");
        return;
      }

    } catch (error) {

      setLoading(false);

      setMessage(
        error.response?.data?.message || "OTP verification failed"
      );

    }

  };


  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#f8fafc",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "24px",
        fontFamily: "monospace",
        color: "#0f172a",
        overflowY: "auto",
        boxSizing: "border-box",
      }}
    >
      {/* HEADER */}
      <header
        style={{
          width: "100%",
          maxWidth: "1280px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e2e8f0",
          paddingBottom: "24px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <img
            src={A1}
            alt="logo"
            style={{
              height: "40px",
            }}
          />

          {/* <span
          style={{
            fontWeight: "700",
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "2px",
          }}
        >
          Cloud Connect
        </span> */}
        </div>
        <button
          //   onClick={onBack}
          onClick={() => navigate('/')}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "700",
            textTransform: "uppercase",
            color: "#000",
          }}
        >
          <ArrowLeft size={14} />
          <span>Back to Login</span>
        </button>
      </header>

      <main
        style={{
          width: "100%",
          maxWidth: "400px",
          margin: "40px auto",
        }}
      >
        {/* STEP 1 - MOBILE NUMBER */}
        {!isOtpSent ? (
          <>
            <div style={{ marginBottom: "32px" }}>
              <h1
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  textTransform: "uppercase",
                  letterSpacing: "2px",
                  marginBottom: "8px",
                }}
              >
                WhatsApp Routing
              </h1>

              <p
                style={{
                  fontSize: "12px",
                  color: "#94a3b8",
                  textTransform: "uppercase",
                }}
              >
                Secure OTP Delivery Protocol
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "#64748b",
                  textTransform: "uppercase",
                }}
              >
                WhatsApp Number
              </label>

              <input
                type="text"
                value={whatsappNumber}
                maxLength={10}
                disabled={isOtpSent}
                onChange={(e) =>
                  setWhatsappNumber(
                    e.target.value.replace(/\D/g, "")
                  )
                }
                placeholder="Enter WhatsApp Number"
                style={{
                  width: "100%",
                  height: "44px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  padding: "0 15px",
                  fontSize: "12px",
                  boxSizing: "border-box",
                  outline: "none",
                }}
              />
            </div>
            <p
              style={{
                fontSize: "10px",
                color: "#94a3b8",
                textTransform: "uppercase",
                letterSpacing: "1px",
                marginTop: "10px",
                lineHeight: "1.6",
              }}
            >
              System will broadcast a one-time authorization token.
            </p>

            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ReCAPTCHA sitekey="6LfB4CIqAAAAABTTABOif9nMWUiFuMfIp31_UU5I" />
            </div>

            <button
              onClick={handleSendOtp}
              disabled={loading}
              style={{
                width: "100%",
                height: "44px",
                backgroundColor: "#000",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "700",
                textTransform: "uppercase",
              }}
            >
              {loading ? "Sending..." : "Transmit Token"}
            </button>
          </>
        ) : (
          <>
            {/* STEP 2 - OTP DESIGN */}

            <div style={{ marginBottom: "32px" }}>
              <h1
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  textTransform: "uppercase",
                  letterSpacing: "2px",
                }}
              >
                Token Verification
              </h1>

              <p
                style={{
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "8px",
                }}
              >
                Dispatched to
                <span
                  style={{
                    fontWeight: "700",
                    color: "#000",
                    marginLeft: "5px",
                  }}
                >
                  {whatsappNumber}
                </span>
              </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "#64748b",
                  textTransform: "uppercase",
                }}
              >
                Enter 6-Digit Cipher
              </label>

              <input
                type="text"
                value={otp}
                maxLength={6}
                onChange={(e) =>
                  setOtp(e.target.value.replace(/\D/g, ""))
                }
                placeholder="Enter OTP"
                style={{
                  width: "100%",
                  height: "44px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  padding: "0 15px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                  outline: "none",
                }}
              />
            </div>

            <button
              onClick={handleVerifyOtp}
              disabled={loading}
              style={{
                width: "100%",
                height: "44px",
                backgroundColor: "#000",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "700",
                textTransform: "uppercase",
              }}
            >
              {loading ? "Verifying..." : "Verify Cipher"}
            </button>
          </>
        )}

        {/* MESSAGE */}
        {message && (
          <div
            style={{
              marginTop: "20px",
              textAlign: "center",
              color: "#dc2626",
              fontSize: "12px",
            }}
          >
            {message}
          </div>
        )}
      </main>


      <footer
        style={{
          width: "100%",
          maxWidth: "1280px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "16px",
          borderTop: "1px solid #e2e8f0",
          paddingTop: "24px",
          fontSize: "10px",
          color: "#94a3b8",
          textTransform: "uppercase",
          letterSpacing: "2px",
        }}
      >
        <p style={{ margin: 0 }}>
          © {new Date().getFullYear()} Cloud Connect Inc.
        </p>

        <div
          style={{
            display: "flex",
            gap: "24px",
          }}
        >
          <a
            href="#"
            style={{
              textDecoration: "none",
              color: "#94a3b8",
            }}
          >
            Privacy
          </a>

          <a
            href="#"
            style={{
              textDecoration: "none",
              color: "#94a3b8",
            }}
          >
            Terms
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Whatsapplogin;
